import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
dayjs.extend(customParseFormat);

/**
 * @description 빈 값 확인 (문자열, 객체, 배열, Map, Set, null, undefined)
 * @param {any} value 확인할 값
 * @returns {boolean} true/false
 */
export const isEmpty = (value) => {
  if (value === null || value === undefined) {
    return true;
  } else if (typeof value === 'string') {
    return value.trim().length === 0;
  } else if (Array.isArray(value)) {
    return value.length === 0;
  } else if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  } else if (value && typeof value === 'object') {
    return Object.keys(value).length === 0;
  } else {
    console.error('잘못된 값을 입력했습니다.');
    return true;
  }
};

/**
 * @description 특수문자, 괄호, 점, 공백 모두 제거하고 문자열만 반환
 * @param {string} str 문자열
 * @returns {string} 특수문자, 괄호, 점, 공백이 제거된 문자열
 */
export const replaceStr = (str) => {
  try {
    if (isEmpty(str)) return '';
    if (typeof str !== 'string') str = String(str);

    const regExp = /[^a-zA-Z0-9ㄱ-힣]/gi;
    return str.replace(regExp, '');
  } catch (error) {
    console.error('문자열 변환 중 오류가 발생했습니다:', error);
    return '';
  }
};

/**
 * @description 날짜 형식 확인
 * @param {string} date 날짜 문자열
 * @returns {boolean} true/false
 */
export const isValidDate = (date, format = 'YYYYMMDD') => {
  return dayjs(date, format, true).isValid();
};
